var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crag-sector-head',{attrs:{"crag-sector":_vm.cragSector}}),_vm._v(" "),_c('crag-sector-description',{attrs:{"crag-sector":_vm.cragSector}}),_vm._v(" "),_c('client-only',[_c('crag-routes',{staticClass:"mt-4 mb-10",attrs:{"crag-sector":_vm.cragSector,"card-elevation":0}}),_vm._v(" "),_c('crag-route-drawer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }